import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import SeoJsonLd from '../../components/SeoJsonLd';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd />
      {/* 네비게이션 */}
      <nav className="fixed w-full z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-4">
              <img
                src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/1fb21cb20452d08dacba0f658c1052b4.jpeg"
                alt="로고"
                className="h-12 w-auto"
              />
              <span className="text-xl font-bold text-gray-900">김영엔지니어링</span>
            </Link>
            <div className="hidden md:flex items-center space-x-8">
              <a href="#home" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                홈
              </a>
              <a href="#services" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                서비스
              </a>
              <a href="#software" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                소프트웨어
              </a>
              <a href="#about" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                회사소개
              </a>
              <a href="#contact" className="px-6 py-2.5 bg-[#0d2b52] text-white text-sm font-semibold rounded-lg hover:bg-[#0a2244] transition-colors whitespace-nowrap cursor-pointer">
                문의하기
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* 히어로 섹션 */}
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/28b03f68d67dd8e01ba257d0ad6552bd.jpeg')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                소방·피난·화재·폭발 소프트웨어
              </h1>
              <p className="text-lg md:text-xl mb-8 text-gray-200 leading-relaxed">
                &quot;하루 커피 한 잔 값으로, 사람을 살리는 소프트웨어&quot;
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-2xl text-teal-400"></i>
                  <span className="text-base">첨단 시뮬레이션 기술 공급 파트너</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-2xl text-teal-400"></i>
                  <span className="text-base">전문 소프트웨어 교육 및 워크숍</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-2xl text-teal-400"></i>
                  <span className="text-base">전문가 시뮬레이션 및 컨설팅 서비스</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-2xl text-teal-400"></i>
                  <span className="text-base">300건 이상의 성공적인 프로젝트 경험</span>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <a href="#services" className="px-8 py-3.5 bg-[#0d2b52] text-white font-semibold rounded-lg hover:bg-[#0a2244] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
                  서비스 보기
                </a>
                <a href="#software" className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer">
                  소프트웨어 솔루션
                </a>
              </div>
            </div>

            <div className="relative">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl overflow-hidden shadow-2xl border border-white/20">
                <img
                  src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/12f002c52c3a506fee30b129ce4a0946.jpeg"
                  alt="시뮬레이션 데모"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <a href="https://youtu.be/3nLh9w4Z--w?si=V5PmMDKaz971gzBD" target="_blank" rel="noopener noreferrer" className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center cursor-pointer hover:bg-white transition-colors shadow-xl">
                    <i className="ri-play-fill text-4xl text-teal-600"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 서비스 섹션 */}
      <section id="services" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              서비스 포트폴리오
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              300건 이상의 시뮬레이션 프로젝트 경험을 보유한 성능기반 소방설계 전문 기업입니다. 소프트웨어 공급부터 전문 컨설팅까지 종합적인 솔루션을 제공합니다.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* 화재 시뮬레이션 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="relative h-64 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/51cdac134417a96d27d3fa9ab1d9e54b.jpeg"
                  alt="화재 시뮬레이션"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">화재 시뮬레이션</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  연기 확산, 가시거리, 구조물 온도를 사실적으로 계산하고 영화 수준의 3D 모델로 시각화하여 종합적인 화재 안전 분석을 제공합니다.
                </p>
                <a href="#contact" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* 피난 시뮬레이션 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="relative h-64 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/a8bc772d3f783d08188b976f3f504df8.jpeg"
                  alt="피난 시뮬레이션"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">피난 시뮬레이션</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  3D로 인간 행동을 모델링하고 혼잡도 및 피난 시간을 계산합니다. 비상 상황 및 일상적인 상황에서의 군중 흐름을 분석합니다.
                </p>
                <a href="#contact" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* 컨설팅 & 교육 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="relative h-64 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/350dafb2bdf0883048154009f7cdad29.jpeg"
                  alt="컨설팅 & 교육"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">컨설팅 &amp; 교육</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  소프트웨어를 직접 사용하기 위한 교육이 필요하시거나 시뮬레이션 서비스 파트너를 찾고 계신다면, 전문가 지도와 지원을 제공합니다.
                </p>
                <a href="#contact" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 소프트웨어 섹션 */}
      <section id="software" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              소프트웨어 솔루션
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              최첨단 시뮬레이션 소프트웨어의 독점 파트너로서, 한국어 버전과 우수한 기술 지원, 맞춤형 교육 프로그램을 제공합니다.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Pipenet */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative h-64 bg-white flex items-center justify-center p-8">
                <img
                  src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/54deb461420056418e63ead275c2ab7f.jpeg"
                  alt="Pipenet"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">PIPENET</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  배관 및 덕트 내 유체 흐름을 신속하게 설계하고 분석하는 소프트웨어입니다.
                </p>
                <a href="https://sunrise-sys.com/pipenet/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-6 py-3 bg-[#0d2b52] text-white font-semibold rounded-lg hover:bg-[#0a2244] transition-colors whitespace-nowrap cursor-pointer">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* BEASY */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative h-64 bg-white flex items-center justify-center p-8">
                <img
                  src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/71431ab74336e6ba5437032557a5ea19.webp"
                  alt="BEASY"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">BEASY</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  업계 최고의 부식 감지 및 방지 솔루션을 제공합니다.
                </p>
                <a href="https://www.beasy.com/software" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-6 py-3 bg-[#0d2b52] text-white font-semibold rounded-lg hover:bg-[#0a2244] transition-colors whitespace-nowrap cursor-pointer">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* ExDAM */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative h-64 bg-white flex items-center justify-center p-12">
                <img
                  src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/184a744f7ba9094cef6c21425c71fd93.png"
                  alt="ExDAM"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">ExDAM</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  (폭발 피해 평가 모델) 부상 및 구조적 피해를 예측하는 3D 폭발 결과 모델링 도구입니다.
                </p>
                <a href="https://shop.trinityconsultants.com/software?_gl=1*1l7lxey*_gcl_au*MjEyMjk5MTY5Mi4xNzcwNjE2NzgxLjEwNTYwNzYzMS4xNzczMDEwNzg2LjE3NzMwMTA3OTc.*_ga*MzY2MTQxMTQwLjE3NzA2MTY3ODE.*_ga_VB50X7KQHK*czE3NzMwMTA3NTkkbzMkZzEkdDE3NzMwMTA4NjAkajI1JGwwJGgyMTQxNTkwOTc4" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-6 py-3 bg-[#0d2b52] text-white font-semibold rounded-lg hover:bg-[#0a2244] transition-colors whitespace-nowrap cursor-pointer">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* PyroSim */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative h-64 bg-white flex items-center justify-center p-8">
                <img
                  src="https://www.simtego.de/wp-content/uploads/2024/04/pyrosim_thumb.jpg"
                  alt="PyroSim"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">PyroSim</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  화재 시뮬레이션을 간편하게. CAD 데이터에서 FDS 모델을 그래픽으로 생성·평가하거나, 몇 번의 클릭만으로 BIM 데이터셋을 모델로 변환하세요.
                </p>
                <a href="https://www.thunderheadeng.com/pyrosim/features/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-6 py-3 bg-[#0d2b52] text-white font-semibold rounded-lg hover:bg-[#0a2244] transition-colors whitespace-nowrap cursor-pointer">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* Pathfinder */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative h-64 bg-white flex items-center justify-center p-8">
                <img
                  src="https://www.simtego.de/wp-content/uploads/2024/04/pathfinder_thumb.jpg"
                  alt="Pathfinder"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Pathfinder</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  피난을 사실적으로 시뮬레이션하고, 화재 시뮬레이션 결과를 원활하게 통합하며, 고급 모델링으로 일상적인 군중 흐름을 최적화합니다.
                </p>
                <a href="#contact" className="inline-flex items-center justify-center w-full px-6 py-3 bg-[#0d2b52] text-white font-semibold rounded-lg hover:bg-[#0a2244] transition-colors whitespace-nowrap cursor-pointer">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* Ventus */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative h-64 bg-white flex items-center justify-center p-8">
                <img
                  src="https://www.simtego.de/wp-content/uploads/2024/08/ventus_logo.jpg"
                  alt="Ventus"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Ventus</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  CAD 데이터로 CONTAM 소프트웨어용 시뮬레이션 모델을 생성합니다. 제연 가압 시스템 및 환기 분석을 위한 건물 압력 조건을 시뮬레이션합니다.
                </p>
                <a href="#contact" className="inline-flex items-center justify-center w-full px-6 py-3 bg-[#0d2b52] text-white font-semibold rounded-lg hover:bg-[#0a2244] transition-colors whitespace-nowrap cursor-pointer">
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 회사소개 섹션 */}
      <section id="about" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                회사소개
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                화재 안전 및 피난 분석 전문 시뮬레이션 소프트웨어 및 컨설팅 서비스를 선도하는 기업입니다. 300건 이상의 완료 프로젝트로 모든 과제에서 탁월한 전문성을 발휘합니다.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                전문가 팀은 최첨단 기술과 실무 경험을 결합하여 최고 수준의 안전성과 효율성을 충족하는 솔루션을 제공합니다. 혁신과 고객 만족에 대한 헌신을 자랑스럽게 생각합니다.
              </p>

              <div className="grid grid-cols-2 gap-6 mb-8">
                <div className="text-center p-6 bg-teal-50 rounded-xl">
                  <div className="text-4xl font-bold text-teal-600 mb-2">300+</div>
                  <div className="text-sm text-gray-600 font-medium">완료 프로젝트</div>
                </div>
                <div className="text-center p-6 bg-teal-50 rounded-xl">
                  <div className="text-4xl font-bold text-teal-600 mb-2">30+</div>
                  <div className="text-sm text-gray-600 font-medium">년 경력</div>
                </div>
                <div className="text-center p-6 bg-teal-50 rounded-xl">
                  <div className="text-4xl font-bold text-teal-600 mb-2">5+</div>
                  <div className="text-sm text-gray-600 font-medium">전문 인력</div>
                </div>
                <div className="text-center p-6 bg-teal-50 rounded-xl">
                  <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
                  <div className="text-sm text-gray-600 font-medium">고객 만족도</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/07e5983fc8d8f124962daceb426bd9ba.jpg"
                  alt="우리 팀"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-teal-600 rounded-2xl -z-10"></div>
              <div className="absolute -top-6 -right-6 w-48 h-48 bg-teal-100 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA 섹션 */}
      <section className="py-24 bg-gradient-to-br from-teal-600 to-teal-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url('data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')`
          }}></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            귀하의 건물을 위한 맞춤 시뮬레이션 솔루션
          </h2>
          <p className="text-xl text-teal-50 mb-10 leading-relaxed">
            전문 컨설팅을 받고 우리의 시뮬레이션 기술이 귀하의 프로젝트 안전성과 효율성을 어떻게 향상시킬 수 있는지 알아보세요.
          </p>
          <a href="#contact" className="inline-block px-10 py-4 bg-white text-[#0d2b52] font-bold rounded-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl text-lg whitespace-nowrap cursor-pointer">
            맞춤 상담 신청
          </a>
        </div>
      </section>

      {/* 문의 섹션 */}
      <section id="contact" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              문의하기
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              궁금한 점이 있거나 프로젝트를 시작하고 싶으신가요? 지금 바로 전문가 팀에 문의하세요.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <div className="bg-gray-50 rounded-2xl p-8 mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">연락처 정보</h3>

                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 mb-1">주소</div>
                      <div className="text-gray-600">서울특별시 금천구 시흥대로 281, 505호</div>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-2xl text-teal-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 mb-1">이메일</div>
                      <a href="mailto:kimyoung@epcmart.co.kr" className="text-teal-600 hover:text-teal-700 cursor-pointer">kimyoung@epcmart.co.kr</a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-2xl text-teal-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 mb-1">전화번호</div>
                      <a href="tel:028077750" className="text-teal-600 hover:text-teal-700 cursor-pointer">02-807-7750</a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-2xl text-teal-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 mb-1">운영 시간</div>
                      <div className="text-gray-600">월요일 - 금요일: 오전 9:00 - 오후 6:00<br />토요일 - 일요일: 휴무</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex space-x-4">
                <a href="#" className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-[#0d2b52] hover:text-white transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-[#0d2b52] hover:text-white transition-colors cursor-pointer">
                  <i className="ri-twitter-fill text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-[#0d2b52] hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-[#0d2b52] hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <form
                className="space-y-6"
                data-readdy-form
                id="contact-form"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const data = new URLSearchParams();

                  formData.forEach((value, key) => {
                    data.append(key, value.toString());
                  });

                  try {
                    const response = await fetch('https://readdy.ai/api/form/d5mmlmrlpot0rgnb7qr0', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                      },
                      body: data.toString(),
                    });

                    if (response.ok) {
                      alert('메시지가 성공적으로 전송되었습니다!');
                      form.reset();
                    } else {
                      alert('메시지 전송에 실패했습니다. 다시 시도해 주세요.');
                    }
                  } catch (error) {
                    alert('오류가 발생했습니다. 다시 시도해 주세요.');
                  }
                }}
              >
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2">
                    성명 *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="홍길동"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                    이메일 주소 *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="example@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-2">
                    전화번호
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="010-1234-5678"
                  />
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-semibold text-gray-900 mb-2">
                    제목 *
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="무엇을 도와드릴까요?"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">
                    메시지 *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all resize-none text-sm"
                    placeholder="프로젝트에 대해 알려주세요..."
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1">최대 500자</div>
                </div>

                <button
                  type="submit"
                  className="w-full px-8 py-4 bg-[#0d2b52] text-white font-semibold rounded-lg hover:bg-[#0a2244] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  메시지 보내기
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* 푸터 */}
      <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div>
              <a href="https://www.youtube.com/@pyrosim1" target="_blank" rel="nofollow noopener noreferrer">
                <img
                  src="https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/d967ebb287448d36f48d035e0e1f2820.png"
                  alt="로고"
                  className="h-12 w-auto mb-6 brightness-0 invert cursor-pointer"
                />
              </a>
              <p className="text-gray-400 text-sm leading-relaxed">
                유튜브에서 pyrosim을 검색하세요!
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">서비스</h4>
              <ul className="space-y-3">
                <li><a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">화재 시뮬레이션</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">피난 시뮬레이션</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">컨설팅 &amp; 교육</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">소프트웨어</h4>
              <ul className="space-y-3">
                <li><a href="#software" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">PIPENET</a></li>
                <li><a href="#software" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">BEASY</a></li>
                <li><a href="#software" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">ExDAM</a></li>
                <li><a href="#software" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">PyroSim</a></li>
                <li><a href="#software" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">Pathfinder</a></li>
                <li><a href="#software" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">Ventus</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">회사</h4>
              <ul className="space-y-3">
                <li><a href="#about" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">회사소개</a></li>
                <li><a href="#contact" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">문의하기</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-gray-400 text-sm">
                Copyright &copy; 김영엔지니어링(주) All rights reserved.
              </p>
              <div className="flex space-x-6">
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">개인정보처리방침</a>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">이용약관</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
